import React from 'react'

import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { HorizontalLinksType } from '@src/Application/Types/ComponentTypes'

import { Button, Content, Image, Link, TitleSection } from './HorizontalLinks.styled'

export const HorizontalLinks = (props: HorizontalLinksType): JSX.Element => {
    const { title, subtitle, mode, description, links, buttonLabel, buttonUrl } = props

    return (
        <TitleSection title={title} subtitle={subtitle} mode={mode} description={description}>
            <>
                <Grid container>
                    {links.map((item, i) => (
                        <Grid
                            item
                            xs={12}
                            md={3}
                            component={Content}
                            key={item.link}
                            spacingRight={3}
                            spacingBottom={3}
                        >
                            <Link to={item.link}>
                                <Image image={item.linkImage} width={30} />
                                {item.label}
                            </Link>
                        </Grid>
                    ))}
                </Grid>
                {buttonLabel && buttonUrl && (
                    <Grid container justifyContent="center">
                        <Link to={buttonUrl}>
                            <Button>{buttonLabel}</Button>
                        </Link>
                    </Grid>
                )}
            </>
        </TitleSection>
    )
}
